// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.out-of-order-clear-copy {
  margin: 0.25rem 0 0;
  font-size: 0.9375rem;
  color: var(--sq-text-2);
  line-height: 1.5;
}

.out-of-order-errors h3 {
  margin: 0 0 0.625rem;
  font-size: 0.875rem;
  font-weight: 650;
}

.out-of-order-empty {
  color: var(--sq-text-3);
  font-size: 0.875rem;
  text-align: center;
  padding: 1.25rem 0;
}

.out-of-order-errors-table {
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-radius-sm);
  overflow: hidden auto;
  max-height: 220px;
}

.out-of-order-errors-row {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
  padding: 0.45rem 0.75rem;
  font-size: 0.8125rem;
  color: var(--sq-text-2);
  border-bottom: 1px solid var(--sq-border);
  overflow-wrap: anywhere;
}
.out-of-order-errors-row:last-child {
  border-bottom: none;
}
.out-of-order-errors-row .align-right {
  text-align: right;
}

.out-of-order-errors-head {
  position: sticky;
  top: 0;
  background: var(--sq-surface-2);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--sq-text-3);
}`, "",{"version":3,"sources":["webpack://./src/components/maintenance/outOfOrderModal.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kCAAA;EACA,kCAAA;EACA,qBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sDAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;EACA,uBAAA;EACA,yCAAA;EACA,uBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,MAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AADF","sourcesContent":[".out-of-order-clear-copy {\n  margin: 0.25rem 0 0;\n  font-size: 0.9375rem;\n  color: var(--sq-text-2);\n  line-height: 1.5;\n}\n\n.out-of-order-errors h3 {\n  margin: 0 0 0.625rem;\n  font-size: 0.875rem;\n  font-weight: 650;\n}\n\n.out-of-order-empty {\n  color: var(--sq-text-3);\n  font-size: 0.875rem;\n  text-align: center;\n  padding: 1.25rem 0;\n}\n\n.out-of-order-errors-table {\n  border: 1px solid var(--sq-border);\n  border-radius: var(--sq-radius-sm);\n  overflow: hidden auto;\n  max-height: 220px;\n}\n\n.out-of-order-errors-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);\n  gap: 0.75rem;\n  align-items: center;\n  padding: 0.45rem 0.75rem;\n  font-size: 0.8125rem;\n  color: var(--sq-text-2);\n  border-bottom: 1px solid var(--sq-border);\n  overflow-wrap: anywhere;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  .align-right {\n    text-align: right;\n  }\n}\n\n.out-of-order-errors-head {\n  position: sticky;\n  top: 0;\n  background: var(--sq-surface-2);\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--sq-text-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
